var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgChatInactive = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 0a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4h-2.9l-4.457 3.763a1 1 0 0 1-1.292 0L6.9 20H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm0 2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h2.9a2 2 0 0 1 1.293.473L12 21.69l3.809-3.217A2 2 0 0 1 17.1 18H20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm-3 11a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm0-4a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm-5-4a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z",
  fill: "#171717",
  fillRule: "evenodd"
})));

export default __webpack_public_path__ + "static/media/chat-inactive.369d3100.svg";
export { SvgChatInactive as ReactComponent };